import { render } from "./OrderViewKiosk.vue?vue&type=template&id=aa5db950&scoped=true"
import script from "./OrderViewKiosk.vue?vue&type=script&lang=js"
export * from "./OrderViewKiosk.vue?vue&type=script&lang=js"

import "./OrderViewKiosk.vue?vue&type=style&index=0&id=aa5db950&scoped=true&lang=scss"

import exportComponent from "/home/sergiugata/taptasty/-taptasty-order/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5db950"]])

export default __exports__